import { Box, CircularProgress, Typography } from "@mui/material"

const SchemeProgressRing = ({ value, total, size = 38 }) => {
  const percent = total ? Math.round((value / total) * 100) : 0

  return (
    <Box
      sx={{ position: "relative", display: "inline-flex", flexShrink: 0 }}
      aria-label={`${value} of ${total} instalments paid`}
    >
      <CircularProgress
        variant="determinate"
        value={100}
        size={size}
        thickness={4}
        sx={{ color: "grey.200" }}
      />
      <CircularProgress
        variant="determinate"
        value={percent}
        size={size}
        thickness={4}
        sx={{ color: "success.main", position: "absolute", left: 0 }}
      />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography sx={{ fontSize: 9.5, fontWeight: 700 }}>
          {value}/{total}
        </Typography>
      </Box>
    </Box>
  )
}

export default SchemeProgressRing
